<!-- 树形选择器 -->
<template>
  <el-select
    ref="select"
    :size="size"
    :value="valueTitle"
    :clearable="clearable"
    @clear="clearHandle"
    :disabled="disabled"
    :placeholder="placeholder"

  >
    <!-- <el-input class="selectInput" :placeholder="placeholder" v-model="filterText"></el-input> -->
    <el-option class="m-scroll" :value="valueTitle" :label="valueTitle">
      <el-tree
        id="tree-option"
        ref="treeSelect"
        :accordion="accordion"
        :data="options"
        :props="props"
        :node-key="props.value"
        :default-expanded-keys="defaultExpandedKey"
        :filter-node-method="filterNode"
        @current-change="handleChange"
       
      ></el-tree>
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "tree-select",
  props: {
    /* 配置项 */
    props: {
      type: Object,
      default: () => {
        return {
          value: "id", // ID字段名
          label: "title", // 显示名称
          children: "children", // 子级字段名
        };

      },
      
    },
    /* 选项列表数据(树形结构的对象数组) */
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    /* 初始值 */
    value: {
      type: Number,
      default: () => {
        return null;
      },
    },
    /* 可清空选项 */
    clearable: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
    /* 自动收起 */
    accordion: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    placeholder: {
      type: String,
      default: () => {
        return "请选择";
      },
    },
    size: {
      type: String,
      default: "mini",
    },
    parentSelect: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filterText: "",
      valueId: this.value, // 初始值
      valueTitle: "",
      defaultExpandedKey: [],
      list: [],
    };
  },
  mounted() {
    this.initScroll();
  },
  watch: {
    value() {
      this.valueId = this.value;
      this.initScroll();
      this.setData()
    },
    filterText(val) {
      this.$refs.treeSelect.filter(val);
    },
  },
  methods: {
    setData() {
      this.$nextTick(() => {
        this.valueId = this.value;
        if (this.valueId) {
          // console.log("setData", this.$refs.treeSelect.getNode(this.valueId));
          let node = this.$refs.treeSelect.getNode(this.valueId);
          if (node) {
            this.valueTitle = node.data[this.props.label]; // 初始化显示
            this.$refs.treeSelect.setCurrentKey(this.valueId); // 设置默认选中
            this.defaultExpandedKey = [this.valueId]; // 设置默认展开
          }
        }
      });
    },
    // 初始化滚动条
    initScroll() {
      this.$nextTick(() => {
        let scrollWrap = document.querySelectorAll(
          ".el-scrollbar .el-select-dropdown__wrap"
        )[0];
        let scrollBar = document.querySelectorAll(
          ".el-scrollbar .el-scrollbar__bar"
        );
        scrollWrap.style.cssText =
          "margin: 0px; max-height: none; overflow: hidden;";
        scrollBar.forEach((ele) => (ele.style.width = 0));
      });
    },
    // 切换选项
    handleChange(node, self) {
      if (this.parentSelect) {
        this.valueTitle = node[this.props.label];
        this.valueId = node[this.props.value];
        this.$emit("node-select", node);
        this.defaultExpandedKey = [];
        this.$refs.select.blur();
      } else {
        if (node.children != undefined) {
          self.isCurrent = false;
          this.$refs.treeSelect.setCurrentKey(this.valueId);
        } else {
          this.valueTitle = node[this.props.label];
          this.valueId = node[this.props.value];
          this.$emit("node-select", node);
          this.defaultExpandedKey = [];
          this.$refs.select.blur();
        }
      }
    },
    // 清除选中
    clearHandle() {
      this.valueTitle = "";
      this.valueId = null;
      this.defaultExpandedKey = [];
      this.clearSelected();
      this.$emit("node-select", null);
    },
    /* 清空选中样式 */
    clearSelected() {
      let allNode = document.querySelectorAll("#tree-option .el-tree-node");
      allNode.forEach((element) => element.classList.remove("is-current"));
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
  height: auto;
  max-height: 245px;
  padding: 0;
  overflow: hidden;
  overflow-y: auto;
}
.el-select-dropdown__item.selected {
  font-weight: normal;
}
ul li >>> .el-tree .el-tree-node__content {
  height: auto;
  padding: 0 20px;
}
.el-tree-node__label {
  font-weight: normal;
}
.el-tree >>> .is-current .el-tree-node__label {
  color: #409eff;
  font-weight: 700;
}
.el-tree >>> .is-current .el-tree-node__children .el-tree-node__label {
  color: #606266;
  font-weight: normal;
}
</style>